export const BASE_URL = "https://api.suleiman.edunixsystem.com/"

export const STORAGE_NAME = "auth"
export const STORAGE_ACTIVE_USER = "active-user"